document.addEventListener('DOMContentLoaded', () => {
    const cartToggleButton = document.getElementById('cart__toggle_button');
    const cartDrawer = document.getElementById('cart-drawer');
    const cartDrawerClose = document.getElementById('cart-drawer-close');
    const cartDrawerBackdrop = document.getElementById('cart-drawer-backdrop');

    function openCartDrawer() {
        cartDrawer.classList.remove('translate-x-full');
        if (cartDrawerBackdrop) {
            cartDrawerBackdrop.classList.remove('opacity-0', 'invisible');
            cartDrawerBackdrop.classList.add('opacity-100', 'visible');
        }
        document.body.style.overflow = 'hidden';
    }

    function closeCartDrawer() {
        cartDrawer.classList.add('translate-x-full');
        if (cartDrawerBackdrop) {
            cartDrawerBackdrop.classList.remove('opacity-100', 'visible');
            cartDrawerBackdrop.classList.add('opacity-0', 'invisible');
        }
        document.body.style.overflow = '';
    }

    if (cartToggleButton) {
        cartToggleButton.addEventListener('click', openCartDrawer);
    }
    
    if (cartDrawerClose) {
        cartDrawerClose.addEventListener('click', closeCartDrawer);
    }
    
    if (cartDrawerBackdrop) {
        cartDrawerBackdrop.addEventListener('click', closeCartDrawer);
    }

    // Remove item from cart
    document.addEventListener('click', function(e) {
        if (e.target.closest('.remove-item')) {
            const button = e.target.closest('.remove-item');
            const variantId = button.dataset.variantId;
            
            fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: 0
                })
            })
            .then(response => response.json())
            .then(data => {
                updateCartDrawer();
            })
            .catch(error => {
                console.error('Error:', error);
            });
        }
    });

    // Update cart drawer content
    function updateCartDrawer() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                const cartItems = document.getElementById('cart-items');
                // Fix: Select the price element specifically (second p element in the footer)
                const cartTotalPrice = document.querySelector('.absolute.bottom-0 .flex.justify-between p.font-medium');
                const checkoutButton = document.querySelector('button[name="checkout"]');
                
                if (cart.items.length === 0) {
                    cartItems.innerHTML = '<div class="text-center"><p>Twój koszyk jest pusty</p></div>';
                    if (cartTotalPrice) {
                        cartTotalPrice.textContent = '0,00 zł';
                    }
                    if (checkoutButton) {
                        checkoutButton.disabled = true;
                        checkoutButton.classList.add('opacity-50');
                    }
                } else {
                    let itemsHTML = '';
                    cart.items.forEach(item => {
                        // Format price comparison logic
                        let priceHTML = '';
                        if (item.original_price > item.final_price) {
                            priceHTML = `
                                <div class="flex items-center gap-2">
                                    <p class="text-sm">${(item.final_price / 100).toFixed(2).replace('.', ',')} zł</p>
                                    <p class="text-xs line-through">${(item.original_price / 100).toFixed(2).replace('.', ',')} zł</p>
                                </div>
                            `;
                        } else {
                            priceHTML = `<p class="text-sm">${(item.final_price / 100).toFixed(2).replace('.', ',')} zł</p>`;
                        }

                        itemsHTML += `
                            <div class="cart-item flex gap-4 mb-6 pb-6 border-b border-gray-600 last:border-b-0" data-variant-id="${item.variant_id}">
                                <div class="w-20 h-full flex-shrink-0">
                                    <img 
                                        src="${item.image}" 
                                        alt="${item.product_title}"
                                        class="w-full h-full object-cover"
                                    />
                                </div>
                                <div class="flex-1 flex flex-col justify-between gap-2">
                                    <div class="flex flex-col gap-2">
                                        <div class="flex flex-col gap-1">
                                            <a 
                                                href="${item.url}"
                                                class="text-white hover:text-white/80 transition-colors duration-300"
                                            >
                                                ${item.product_title.toUpperCase()}
                                            </a>
                                            <p class="text-xs text-[#7B7B7B]">${item.product_type}</p>
                                        </div>
                                        <div class="flex flex-col gap-1">
                                            <p class="text-xs">rozmiar: ${item.variant_title}</p>
                                            <p class="text-xs">ilość: ${item.quantity}</p>
                                        </div>
                                    </div>
                                    ${priceHTML}
                                </div>
                                <button
                                    type="button"
                                    class="remove-item self-start stroke-white hover:stroke-white/80 transition-colors duration-300 cursor-pointer"
                                    data-variant-id="${item.variant_id}"
                                >
                                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18.3332 8.25L16.5044 18.6508C16.3503 19.5274 15.5889 20.1667 14.6989 20.1667H7.30085C6.41081 20.1667 5.64935 19.5274 5.49522 18.6508L3.6665 8.25H18.3332Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M19.25 5.5H14.0938M14.0938 5.5V3.66667C14.0938 2.65415 13.273 1.83334 12.2604 1.83334H9.73958C8.72706 1.83334 7.90625 2.65415 7.90625 3.66667V5.5M14.0938 5.5H7.90625M2.75 5.5H7.90625" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </button>
                            </div>
                        `;
                    });
                    
                    cartItems.innerHTML = itemsHTML;
                    
                    // Update total price
                    if (cartTotalPrice) {
                        cartTotalPrice.textContent = `${(cart.total_price / 100).toFixed(2).replace('.', ',')} zł`;
                    }
                    
                    // Enable checkout button
                    if (checkoutButton) {
                        checkoutButton.disabled = false;
                        checkoutButton.classList.remove('opacity-50');
                    }
                }
            })
            .catch(error => {
                console.error('Error updating cart:', error);
            });
    }

    // Listen for cart updates
    document.addEventListener('cart:updated', updateCartDrawer);
    
    // Expose functions globally for other scripts
    window.cartDrawer = {
        open: openCartDrawer,
        close: closeCartDrawer,
        update: updateCartDrawer
    };
});